import React from 'react';
import { useHistory } from 'react-router-dom';

import { WALLETS } from '../constants';
import { useConnect } from '../hooks/useConnect';

function ConnectWallet() {
    const { connect } = useConnect();
    const history = useHistory();

    const walletConnect = async (key) => {
        if (key === 'Metamask') {
            connect(WALLETS[0]);
        } else if (key === 'Wallet Connect') {
            console.log('Try to connect Wallet');
            connect(WALLETS[1]);
        }
        history.goBack();
    };
    return (
        <div style={{ height: '67vh' }}>
            <div className="connect-wallet">
                <div className="container">
                    <div className="col-lg-8 col-head-otr">
                        <h2 className="connect-heading heading-h2">
                            Connect Wallet
                        </h2>
                    </div>
                    <span className="line"></span>
                    <div className="col-lg-8 col-connect-otr">
                        <div className="col-connect-inr">
                            <p className="desc body-m">
                                You can connect your wallet with one of the
                                following wallet providers.
                            </p>
                            <div className="row row-boxes">
                                <div className="col-lg-4 col-md-4 col-sm-6 col-box-otr">
                                    <div
                                        className="box-inr box-1"
                                        onClick={() =>
                                            walletConnect('Metamask')
                                        }
                                    >
                                        <div className="icon-otr">
                                            <img
                                                className="icon"
                                                src="../assets/img/wallet-icon-1.png"
                                                alt="icon"
                                            />
                                        </div>
                                        <h5 className="head heading-h5">
                                            MetaMask
                                        </h5>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-box-otr">
                                    <div
                                        className="box-inr box-2"
                                        onClick={() =>
                                            walletConnect('Wallet Connect')
                                        }
                                    >
                                        <div className="icon-otr">
                                            <img
                                                className="icon"
                                                src="../assets/img/wallet-icon-2.png"
                                                alt="icon"
                                            />
                                        </div>
                                        <h5 className="head heading-h5">
                                            WalletConnect
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConnectWallet;
